import { MonetizableEnum } from '@ria-client/segment/enums';
import { EntityPlacementCtaTypeEnum } from '@ria-client/supergraph/marketplace/enums';
import type { FinancialAdvisorsSummaryTableEntityType } from '@ria-client/supergraph/structuredContent/hydration/FinancialAdvisorsSummaryTable/types';
import { CtaButton } from '@ria-client/tw-shared-ui';
import { RiaDisclaimer } from './ria-disclaimer';

export interface OfferCtaProps {
  marketplaceEntity: FinancialAdvisorsSummaryTableEntityType;
  index: number;
  monetizingCtaLabel?: string;
  displayAdLabel?: boolean;
}

export function OfferCta({
  marketplaceEntity,
  index,
  monetizingCtaLabel,
  displayAdLabel,
}: OfferCtaProps) {
  const { applyLink, cta: marketplaceCta, isMonetizing, reviewLink } = marketplaceEntity;
  const ctaLink = isMonetizing ? applyLink || marketplaceCta?.link : reviewLink;

  if (!ctaLink) return null;

  const cta = isMonetizing
    ? {
        link: ctaLink,
        text: monetizingCtaLabel || marketplaceCta?.text || 'Learn more',
        type: marketplaceCta?.type ?? EntityPlacementCtaTypeEnum.ApplyNow,
        subtext: undefined,
        showIcon: true,
      }
    : {
        link: ctaLink,
        text: 'Read review',
        type: marketplaceCta?.type ?? EntityPlacementCtaTypeEnum.ReadReview,
        subtext: undefined,
        showIcon: false,
      };
  const annotationText = isMonetizing ? marketplaceCta?.subtext : 'on NerdWallet';

  return (
    <div
      className="flex w-[155px] flex-col gap-y-11 pb-7 sm:w-[225px] md:w-auto md:flex-row lg:flex-col"
      data-testid="cta-button"
    >
      <div className="flex w-[300px] flex-col gap-2 md:w-[220px] lg:w-auto lg:max-w-[250px]">
        <div className="flex w-full flex-col items-center">
          <CtaButton
            analyticsPayload={{
              index,
              institutionId: marketplaceEntity.institution.id,
              monetizable: marketplaceEntity.monetizable as MonetizableEnum,
              offerId: marketplaceEntity.id,
              productId: marketplaceEntity.product.id,
              productType: marketplaceEntity.productType,
            }}
            cta={cta}
            fullWidth
            size="dense"
          />
          <span className="typography-text-small mt-2 text-center text-muted-foreground">
            {annotationText}
          </span>
          {displayAdLabel && marketplaceEntity.isRiaOffer && marketplaceEntity.riaDisclaimerText ? (
            <div className="mt-2">
              <RiaDisclaimer
                monetizable={marketplaceEntity.monetizable as MonetizableEnum}
                riaDisclaimerText={marketplaceEntity.riaDisclaimerText}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
